import {
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSImage,
  WSMessageBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { queriesInvoiceRows } from "@query";
import React from "react";
import smile from "../../../assets/images/party-smile.png";

type Props = WSElementProps;

// A single row is enough — the count comes from the response `summary`.
const COUNT_PAGE = { size: 1 };

export const FirstInvoiceBanner: React.FC<Props> = ({ ...elementProps }) => {
  // Recurring/scheduled invoice templates still create through the retired
  // v1 API (V3_MIGRATION_TRACKER.md: /v3/payments/recurring-invoices 501s),
  // so this can only count real invoices, not templates.
  const queryInvoices = queriesInvoiceRows.searchInvoiceRows.useQuery({
    page: COUNT_PAGE
  });
  const hasOneInvoice = queryInvoices.data?.summary?.count === 1;

  if (!hasOneInvoice) {
    return null;
  }

  return (
    <WSElement {...elementProps}>
      <WSMessageBox noBorder>
        <WSFlexBox.Center>
          <WSImage src={smile} placeholder={<></>} width={16} />
          <WSText ml="M">You just sent your first invoice!!</WSText>
        </WSFlexBox.Center>
      </WSMessageBox>
    </WSElement>
  );
};
